var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatsTeardrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.75H2.34375C2.21943 13.75 2.1002 13.7006 2.01229 13.6127C1.92439 13.5248 1.875 13.4056 1.875 13.2812V8.125C1.875 6.63316 2.46763 5.20242 3.52252 4.14752C4.57742 3.09263 6.00816 2.5 7.5 2.5V2.5C8.99184 2.5 10.4226 3.09263 11.4775 4.14752C12.5324 5.20242 13.125 6.63316 13.125 8.125V8.125C13.125 9.61684 12.5324 11.0476 11.4775 12.1025C10.4226 13.1574 8.99184 13.75 7.5 13.75V13.75Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19531 13.75C7.58313 14.8469 8.30154 15.7966 9.25158 16.4682C10.2016 17.1398 11.3365 17.5003 12.5 17.5H17.6562C17.7806 17.5 17.8998 17.4506 17.9877 17.3627C18.0756 17.2748 18.125 17.1556 18.125 17.0312V11.875C18.127 10.4353 17.5761 9.04972 16.5861 8.00443C15.596 6.95914 14.2424 6.3339 12.8047 6.25781",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsTeardrop);
export default __webpack_public_path__ + "static/media/chats-teardrop.0f215ef46e26e2406d0078a2a9f4f7d3.svg";
export { ForwardRef as ReactComponent };